module.exports = __webpack_public_path__ + "static/img/12.52226023.jpg";